/**
 * 路口年度建设数量走势组件
 * zxw
 * 2024-08-12
 */

import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import DualAxes from '@ant-design/plots/es/components/dual-axes';
import $ from 'jquery';
import { UjoinParams, AddRequestHeaders, winWidth } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const IntersectionITYEC = (props) => {
    const [data, setData] = useState([]);

    /**
     * 根据mod获取路口统计报表数据
     * @param {*} mod 
     */
    const getData = (mod) => {
        const params = {
            'mod': mod,
        }
        $.ajax({
            url: `${CNF.api}report/intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
            dataType: 'JSON',success:function(data){
                if(data.res === 0){
                    if(data.dat.length>0){
                        setData(data.dat);
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    useEffect(()=>{
        getData('ITYEC');
    },[]);

    const config = {
        data: data,
        width: winWidth-(props.collapsed?80:200)-50,
        xField: (d)=>{return d.year + '年'},
        children: [
            {
                type: 'line',
                yField: 'count',
                shapeField: 'smooth',
                style: {
                    stroke: '#44CCCC',
                    lineWidth: 2,
                },
                tooltip: {
                    title: (d) => {
                        return d.year + '年';
                    },
                    items: [{ field: 'count',name: '建设数量', valueFormatter: (count) => `${count}` + '个', }],
                }
            },
            {
                type: 'point',
                yField: 'count',
                sizeField: 4,
                style: {
                  stroke: '#44CCCC',
                  fill: '#fff',
                },
                axis: { y: false },
                tooltip: false,
              },
        ],
        animate: {
            enter: {
                type: 'pathIn',
                duration: 3000,
            },
        },
    };
    return <>
        <div style={{ padding: '50px 25px',width: winWidth-(props&&props.collapsed?80:200) }}>
            <DualAxes width={'100%'} {...config} />
        </div>
    </>
}

export default IntersectionITYEC;